<template>
  <div class="default-layout">
    <van-grid :column-num="3" :icon-size="16">
        <van-grid-item  v-for="region in regions" :key="region.value" @click="handleOpenAddDialog(region)">
          <div slot="icon"><img src="../images/icobill.png" alt=""/></div>
          <span slot="text">{{region.label}}</span>
      </van-grid-item>
    </van-grid>
  </div>
</template>

<script>
import originCertificateRegion from '../service/origin-certificate-region'

export default {
  name: "ApplicationRegion",
  data() {
    return {
      regions: originCertificateRegion.getRegions()
    }
  },
  components: {},
  computed: {},
  created() {

  },
  mounted() {

  },
  methods: {
    async handleOpenAddDialog(region) {
      let routePath = "#";
      switch (region.category) {
        case "GENERAL":
          routePath = '/general-origin-certificate/general-application';
          break;
        case "PREF":
          routePath = '/pref-origin-certificate/pref-application';
          break;
        case "RCEP":
          routePath = '/origin-certificate/application';
          break;
      }
      await this.$router.push({
        path: routePath,
        query: {
          region: JSON.stringify(region)
        }
      });
      await this.$store.dispatch('app-theme/deleteCachedRoutes','ApplicationComponent');
      await this.$store.dispatch('app-theme/deleteCachedRoutes','PrefApplicationComponent');
      await this.$store.dispatch('app-theme/deleteCachedRoutes','GeneralApplicationComponent');
      this.$emit('close');
    },
  }
}
</script>

<style lang="scss" scoped>
@import "src/app-theme/style/rcep-layout";

::v-deep(.van-grid-item__content) {
  justify-content: unset;
  height: 140px;

  span {
    text-align: center;
  }

}
</style>